import { render } from "./ListPoints.vue?vue&type=template&id=3292ce16&scoped=true"
import script from "./ListPoints.vue?vue&type=script&lang=js"
export * from "./ListPoints.vue?vue&type=script&lang=js"

import "./ListPoints.vue?vue&type=style&index=0&id=3292ce16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3292ce16"]])

export default __exports__